import { useParams } from 'react-router-dom';

const dummyContent = `<h4>Apple’s iOS update will significantly impact the way creators track advertisements on Facebook. Continue reading to find out how connecting a custom domain will allow you to continue using your Facebook pixel.</h4><p></p><p>Apple’s upcoming<a href="https://www.facebook.com/business/help/331612538028890?id=428636648170202"> iOS 14</a> update will moderate the amount of data iPhone apps can collect, restricting advertising on all social media platforms. If you’re a creator that advertises using the Facebook pixel, you will be affected by this update. iOS 14 is expected to roll out in early Spring. For that reason, we’re encouraging you to start preparing.</p><p>Facebook receives and processes conversion events and other optimization goals from tools like the Facebook pixel. Creators who have set up the Facebook pixel previously within the <a href="https://teespring.com/dashboard/marketing">Spring dashboard</a> will need to take note of the following changes.</p><p></p><h4>One pixel per domain</h4><p>The biggest change this update is bringing is the fact that Facebook will only allow one tracking pixel per domain. If your store has not been connected with a custom domain, it will stop collecting valuable sales conversion data. Over the next few weeks all creator stores will be upgraded to a <a href="http://www.spri.ng/creator-resources/customizing-your-store">custom store</a>. Once you’ve been upgraded, you’ll be able to connect a custom domain.&nbsp;</p><p>Please note, <strong>one custom domain</strong> can be supported <strong>per Spring account</strong>. Creators with multiple stores need to choose one store to connect a custom domain to. We recommend choosing your primary store used in advertisements.</p><p></p><h4>Custom domains</h4><p>Once you’ve been upgraded to a custom store you’re able to purchase and connect a <a href="https://www.spri.ng/creator-resources/connecting-a-custom-domain" target="_blank" rel="noreferrer noopener">custom domain</a>. You must use a custom domain in order for the Facebook tracking pixel to work.&nbsp;</p><p></p><figure class="wp-block-image size-large"><img loading="lazy" width="1024" height="624" src="https://springblogdev.wpengine.com/wp-content/uploads/2021/02/iOS-asset-1024x624.png" alt="" class="wp-image-36194" srcset="https://springblogdev.wpengine.com/wp-content/uploads/2021/02/iOS-asset-1024x624.png 1024w, https://springblogdev.wpengine.com/wp-content/uploads/2021/02/iOS-asset-300x183.png 300w, https://springblogdev.wpengine.com/wp-content/uploads/2021/02/iOS-asset-768x468.png 768w, https://springblogdev.wpengine.com/wp-content/uploads/2021/02/iOS-asset-1536x936.png 1536w, https://springblogdev.wpengine.com/wp-content/uploads/2021/02/iOS-asset-2048x1248.png 2048w, https://springblogdev.wpengine.com/wp-content/uploads/2021/02/iOS-asset-1200x731.png 1200w, https://springblogdev.wpengine.com/wp-content/uploads/2021/02/iOS-asset-1980x1207.png 1980w" sizes="(max-width: 1024px) 100vw, 1024px" /></figure><p></p><ol><li>Only one pixel can be used per domain, and only one domain can be connected to one store per Spring account. Make sure to connect the domain for the primary store you intend to advertise for.&nbsp;</li><li>Next, you’ll need to <a href="https://developers.facebook.com/docs/sharing/domain-verification/verifying-your-domain/">verify your domain</a> and choose the conversion events you want to track on Facebook. &nbsp;</li><li>Once step 4 is complete, you can update the product and store links displayed in your Facebook ads to feature your new domain.&nbsp;</li></ol><p></p><p>We are currently rolling out the ability for users to purchase a custom domain hosted through Spring. If you purchase a domain through us, we’re able to verify the domain for you and offer additional support. Keep an eye on your account to see when you get access.&nbsp;</p><p>Click the link below to learn more about connecting a custom domain to your store.</p><p></p><div class="wp-block-buttons"><div class="wp-block-button"><a class="wp-block-button__link" href="https://www.spri.ng/creator-resources/connecting-a-custom-domain" target="_blank" rel="noreferrer noopener">Custom domains</a></div></div><p></p><p></p>`;

export const categories = [
  {
    databaseId: 'orders',
    name: 'About my order',
    icon: 'Save',
    posts: [
      {
        databaseId: 'track-order',
        slug: 'track-my-order',
        title: 'Track my order'
      },
      {
        databaseId: 'cart',
        slug: 'the-shopping-cart',
        title: 'The shopping cart'
      },
      {
        databaseId: 'place-order',
        slug: 'placing-an-order',
        title: 'Placing an order'
      },
      {
        databaseId: 'faq-digital',
        slug: 'faqs-digital-products',
        title: 'FAQs: Digital products'
      }
    ]
  },
  {
    databaseId: 'shipping',
    name: 'Shipping',
    icon: 'Truck',
    posts: [
      {
        databaseId: 'shipping-costs',
        slug: 'shipping-costs',
        title: 'Shipping costs'
      },
      {
        databaseId: 'shipping-time',
        slug: 'shipping-time-frames',
        title: 'Shipping time frames'
      }
    ]
  },
  {
    databaseId: 'billing',
    name: 'Billing',
    icon: 'CreditCard',
    posts: [
      {
        databaseId: 'billing-fees',
        slug: 'sales-tax-vats-customs-fees',
        title: 'Sales Tax / VATS & Customs Fees'
      },
      {
        databaseId: 'billing-payments',
        slug: 'payments',
        title: 'Payments'
      }
    ]
  },
  {
    databaseId: 'policies',
    name: 'Understanding our policies',
    icon: 'FileText',
    posts: [
      {
        databaseId: 'policies-acceptable-use',
        slug: 'acceptable-use-policy',
        title: 'Acceptable use policy'
      },
      {
        databaseId: 'policies-repeat-infringer',
        slug: 'repeat-infringer-policy',
        title: 'Repeat infringer policy'
      }
    ]
  }
];

export const posts = [
  {
    databaseId: 'track-order',
    slug: 'track-my-order',
    title: 'Track my order',
    categories: [
      {
        databaseId: 'orders',
        name: 'Orders'
      }
    ],
    content: dummyContent
  },
  {
    databaseId: 'cart',
    slug: 'the-shopping-cart',
    title: 'The shopping cart',
    categories: [
      {
        databaseId: 'orders',
        name: 'Orders'
      }
    ],
    content: dummyContent
  },
  {
    databaseId: 'place-order',
    slug: 'placing-an-order',
    title: 'Placing an order',
    categories: [
      {
        databaseId: 'orders',
        name: 'Orders'
      }
    ],
    content: dummyContent
  },
  {
    databaseId: 'faq-digital',
    slug: 'faqs-digital-products',
    title: 'FAQs: Digital products',
    categories: [
      {
        databaseId: 'orders',
        name: 'Orders'
      }
    ],
    content: dummyContent
  },
  {
    databaseId: 'shipping-costs',
    slug: 'shipping-costs',
    title: 'Shipping costs',
    categories: [
      {
        databaseId: 'shipping',
        name: 'Shipping'
      }
    ],
    content: dummyContent
  },
  {
    databaseId: 'shipping-time',
    slug: 'shipping-time-frames',
    title: 'Shipping time frames',
    categories: [
      {
        databaseId: 'shipping',
        name: 'Shipping'
      }
    ],
    content: dummyContent
  },
  {
    databaseId: 'billing-fees',
    slug: 'sales-tax-vats-customs-fees',
    title: 'Sales Tax / VATS & Customs Fees',
    categories: [
      {
        databaseId: 'billing',
        name: 'Billing'
      }
    ],
    content: dummyContent
  },
  {
    databaseId: 'billing-payments',
    slug: 'payments',
    title: 'Payments',
    categories: [
      {
        databaseId: 'billing',
        name: 'Billing'
      }
    ],
    content: dummyContent
  },
  {
    databaseId: 'policies-acceptable-use',
    slug: 'acceptable-use-policy',
    title: 'Acceptable use policy',
    categories: [
      {
        databaseId: 'policies',
        name: 'Policies'
      }
    ],
    content: dummyContent
  },
  {
    databaseId: 'policies-repeat-infringer',
    slug: 'repeat-infringer-policy',
    title: 'Repeat infringer policy',
    categories: [
      {
        databaseId: 'policies',
        name: 'Policies'
      }
    ],
    content: dummyContent
  }
];

export const useSupport = () => {
  const { postSlug } = useParams();
  const activePost = posts.find(post => post.slug === postSlug);
  return { categories, posts, activePost };
};
